import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import BoxInput from '../BoxInput/BoxInput';
import IconReusable from '../../../components/IconReusable';
import { CustomButton } from '../../../v2/MUI_custom_component';
import { encryptPassword } from '../../../v2/Utils/Encryption/NodeForgeEncryption';
import { toast } from 'react-toastify';
import { EPIN_REGEX } from '../../Auth/Register/Components/regex';

const EpinCreation = ({
  onCreateEpin,
  onSuccess,
  onError,
  title = "Create e-Pin",
  confirmEpinRequired = true,
  epinLength = 6,
  buttonLabel = "Save e-Pin",
  loading = false,
  CancelButtonhandler,
  CancelButtonLabel
}) => {
  const [epin, setEpin] = useState('');
  const [confirmEpin, setConfirmEpin] = useState('');
  const [epinErr, setEpinErr] = useState('');
  const [confirmEpinErr, setConfirmEpinErr] = useState('');
  const [apiError, setApiError] = useState('');

  const validateEpin = () => {
    let epinError = '';
    let confirmEpinError = '';

    if (!epin) {
      epinError = 'e-Pin is required';
    } else if (!/^\d{6}$/.test(epin)) {
      epinError = 'e-Pin must be 6 digits';
    }

    if (confirmEpinRequired) {
      if (!confirmEpin) {
        confirmEpinError = 'Confirmation e-Pin is required';
      } else if (!/^\d{6}$/.test(confirmEpin)) {
        confirmEpinError = 'Confirmation e-Pin must be 6 digits';
      } else if (epin !== confirmEpin) {
        confirmEpinError = 'The confirm e-PIN does not match';
      }
    }

    setEpinErr(epinError);
    setConfirmEpinErr(confirmEpinError);
    
    return !epinError && !confirmEpinError;
  };

  const handleCreateEpin = async () => {
    if (!validateEpin()) {
      return;
    }
    setApiError('');
    const encryptedEpin = encryptPassword(epin);
    const encryptedConfirmEpin = confirmEpinRequired ? encryptPassword(confirmEpin) : null;
    
    const {data, error, message} = await onCreateEpin({ 
      epin: encryptedEpin, 
      confirmEpin: encryptedConfirmEpin 
    });
    
    if (!error) {
      onSuccess?.(data);
      toast.success(message);
    } else {
      setApiError(message);
      onError?.(message);
    }
  };

  const clearErrors = () => {
    setEpinErr('');
    setConfirmEpinErr('');
    setApiError('');
  };

  const handleEpinChange = (val) => {
    setEpin(val);
    if (epinErr) clearErrors();
  };

  const handleConfirmEpinChange = (val) => {
    setConfirmEpin(val);
    if (confirmEpinErr) setConfirmEpinErr('');
    if (val.length === epinLength && epin.length === epinLength && val !== epin) {
      setConfirmEpinErr('The confirm e-PIN does not match');
    }
  };
  const isEPinFormValid = EPIN_REGEX.test(epin) && EPIN_REGEX.test(confirmEpin);
  

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: apiError ? 1 : 0 }}>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
          <BoxInput
            label="Enter e-Pin*"
            length={epinLength}
            value={epin}
            onChange={handleEpinChange}
            type="password"
            showEyeIcon={true}
            error={!!epinErr}
            stretchToFit={true}
          />
          {epinErr && (
            <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>
              {epinErr}
            </Typography>
          )}

          {confirmEpinRequired && (
            <>
              <BoxInput
                label="Confirm e-Pin*"
                length={epinLength}
                value={confirmEpin}
                onChange={handleConfirmEpinChange}
                type="password"
                showEyeIcon={true}
                error={!!confirmEpinErr}
                stretchToFit={true}
              />
              {confirmEpinErr && (
                <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>
                  {confirmEpinErr}
                </Typography>
              )}
            </>
          )}
        </Box>

        {apiError && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
            <Typography variant='body1' sx={{ color: '#CC0000' }}>
              {apiError}
            </Typography>
          </Box>
        )}
      </Box>

      <CustomButton 
        variant='filled'
        disabled={loading || !isEPinFormValid || !!confirmEpinErr}
        label={buttonLabel}
        fullWidth
        onClick={handleCreateEpin}
      />
      <CustomButton 
        variant='text'
        label={CancelButtonLabel || 'Cancel'}
        fullWidth
        onClick={CancelButtonhandler}
      />
    </Box>
  );
};

export default EpinCreation;